import darkTheme from './dark.theme';

const themes = {
  dark: darkTheme,
};

export default themes;
